// frontend/src/components/ProviderServices/EmptyServicesState.tsx
import React from 'react';
import { Search, MessageSquare, Plus } from 'lucide-react';

interface EmptyServicesStateProps {
  onBrowseServices: () => void;
  onRequestService: () => void;
}

const EmptyServicesState: React.FC<EmptyServicesStateProps> = ({
  onBrowseServices,
  onRequestService,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-8 text-center">
      <div className="text-gray-400 mb-4">
        <Search size={48} className="mx-auto" />
      </div>
      
      <h3 className="text-lg font-medium text-gray-900 mb-2">No Services Added Yet</h3>
      
      <p className="text-gray-500 mb-6 text-sm">
        Start building your service portfolio by browsing available services or request a new one 
        if you don't find what you're looking for.
      </p>
      
      <div className="space-y-3">
        <button
          onClick={onBrowseServices}
          className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg font-medium hover:bg-blue-700 flex items-center justify-center"
        >
          <Plus size={18} className="mr-2" />
          Browse Available Services
        </button>
        
        <button
          onClick={onRequestService}
          className="w-full bg-gray-600 text-white px-4 py-3 rounded-lg font-medium hover:bg-gray-700 flex items-center justify-center"
        >
          <MessageSquare size={18} className="mr-2" />
          Request New Service
        </button>
      </div>
      
      <div className="mt-6 pt-6 border-t border-gray-100">
        <p className="text-xs text-gray-500">
          💡 <strong>Tip:</strong> Adding multiple services increases your visibility to potential customers
        </p>
      </div>
    </div>
  );
};

export default EmptyServicesState;